import { theme } from "../theme";
const getNextBreakpoint = (currentBreakpoint, breakpoints) => {
    const { screens } = theme;
    let nextBreakpoint = undefined;
    for (const breakpoint of breakpoints) {
        if (screens[breakpoint] > screens[currentBreakpoint] &&
            (!nextBreakpoint || screens[breakpoint] < screens[nextBreakpoint])) {
            nextBreakpoint = breakpoint;
        }
    }
    return nextBreakpoint;
};
export const createResponsiveStyles = ({ base, ...breakpointStyles }) => {
    return {
        ...base,
        ...Object.entries(breakpointStyles).reduce(({ previousStyles, finalStyles }, [screen, styles]) => {
            if (styles) {
                const nextBreakpoint = getNextBreakpoint(screen, Object.keys(breakpointStyles));
                finalStyles[`@media (min-width: ${theme.screens[screen]}px)${nextBreakpoint
                    ? ` and (max-width: ${theme.screens[nextBreakpoint]}px)`
                    : ""}`] = { ...previousStyles, ...styles };
            }
            return {
                previousStyles: { ...previousStyles, ...styles },
                finalStyles,
            };
        }, { previousStyles: {}, finalStyles: {} }).finalStyles,
    };
};
//# sourceMappingURL=createResponsiveStyles.js.map